import { jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { MouseSensor, useSensor, useSensors, DndContext } from "@dnd-kit/core";
import {
  SortableContext,
  horizontalListSortingStrategy,
  arrayMove as dndArrayMove
} from "@dnd-kit/sortable";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
const CustomTheadComponent = ({
  children: _children,
  className,
  moveColumn,
  sortedItemsFull,
  style
}) => {
  const children = _children.props.children;
  const [sortedItems, setSortedItems] = useState(
    () => children.map((c) => {
      return c.props.path || c.key.split("-")[1];
    })
  );
  useEffect(() => {
    setSortedItems(children.map((c) => c.props.path || c.key.split("-")[1]));
  }, [children]);
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 10
    }
  });
  const sensors = useSensors(mouseSensor);
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || !active) {
      return;
    }
    if (active.id === over.id) {
      return;
    }
    const oldPath = active.id;
    const newPath = over.id;
    const oldIndex = sortedItemsFull.indexOf(oldPath);
    const newIndex = sortedItemsFull.indexOf(newPath);
    const newSortedItems = dndArrayMove(sortedItemsFull, oldIndex, newIndex);
    setSortedItems(newSortedItems);
    moveColumn({ oldIndex, newIndex });
  };
  return /* @__PURE__ */ jsx(
    DndContext,
    {
      onDragEnd: handleDragEnd,
      modifiers: [restrictToHorizontalAxis],
      sensors,
      children: /* @__PURE__ */ jsx("div", { className: "rt-thead " + className, style, children: /* @__PURE__ */ jsx("div", { className: "rt-tr", children: /* @__PURE__ */ jsx(
        SortableContext,
        {
          items: sortedItems,
          strategy: horizontalListSortingStrategy,
          children
        }
      ) }) })
    }
  );
};
const SortableColumns = ({
  className,
  style,
  children,
  moveColumn,
  sortedItemsFull
}) => {
  const shouldCancelStart = (e) => {
    const className2 = e.target.className;
    return e.target instanceof SVGElement || className2.indexOf("rt-resizer") > -1;
  };
  return /* @__PURE__ */ jsx(
    CustomTheadComponent,
    {
      className,
      style,
      sortedItemsFull,
      moveColumn,
      helperClass: "above-dialog",
      shouldCancelStart,
      children
    }
  );
};
export default SortableColumns;
